import { ItemAcceptanceCancellationQueryURL, ItemAcceptanceCancellationCommandURL } from './ItemAcceptanceCancellation';
import { PlanningCommandURL, PlanningQueryURL } from './Planning';
import { MannequinCommandURL, MannequinQueryURL } from './Mannequin';
import { AIGeneratorCommandURL } from './AIGenerator';
import { StudioPromptCommandURL, StudioPromptQueryURL } from './StudioPrompt';
import { AIStudioAnalyticsQueryURL } from './AIStudioAnalytics';
import { AIProcessLogQueryURL } from './AIProcessLog';
import { BackgroundLabelCommandURL, BackgroundLabelQueryURL } from './BackgroundLabel';
import { AIGenerationTypeCommandURL, AIGenerationTypeQueryURL } from './AIGenerationType';
import { StudioAddressBarcodeCommandURL, StudioAddressBarcodeQueryURL } from './StudioAddressBarcode/index';
import { StudioProductStatusQueryURL } from './StudioProductStatus/index';
import { StudioFileManagerCommandURL, StudioFileManagerQueryURL } from './StudioFileManager/index';
import { StudioShotReportQueryURL } from './StudioShotReport/index';
import { StudioProductStatusFlowReportQueryURL } from './StudioProductStatusFlowReport/index';
import { MatchingSetPendingReportQueryURL } from './MatchingSetPendingReport/index';
import { PendingRetouchTransfersQueryURL } from './PendingRetouchTransfers/index';
import { RawImageUploadQueryURL, RawImageUploadCommandURL } from './RawImageUpload/index';
import { RawImageReviewQueryURL } from './RawImageReview/index';
import { BatchOutputQueryURL, BatchOutputCommandURL } from './BatchOutput/index';
import { BatchProcessTrackingQueryURL, BatchProcessTrackingCommandURL } from './BatchProcessTracking/index';
import { ProductPomMeasurementQueryURL } from './ProductPomMeasurement';
import { AiIntegrationCommandURL } from './AiIntegration/index';

export const StudioCommandURLs = {
    ItemAcceptanceCancellationCommandURL,
    PlanningCommandURL,
    MannequinCommandURL,
    AIGeneratorCommandURL,
    StudioPromptCommandURL,
    BackgroundLabelCommandURL,
    AIGenerationTypeCommandURL,
    StudioAddressBarcodeCommandURL,
    StudioFileManagerCommandURL,
    RawImageUploadCommandURL,
    AiIntegrationCommandURL,
    BatchOutputCommandURL,
    BatchProcessTrackingCommandURL,
};

export const StudioQueryURLs = {
    ItemAcceptanceCancellationQueryURL,
    PlanningQueryURL,
    MannequinQueryURL,
    StudioPromptQueryURL,
    AIStudioAnalyticsQueryURL,
    AIProcessLogQueryURL,
    BackgroundLabelQueryURL,
    AIGenerationTypeQueryURL,
    StudioAddressBarcodeQueryURL,
    StudioProductStatusQueryURL,
    StudioFileManagerQueryURL,
    StudioShotReportQueryURL,
    StudioProductStatusFlowReportQueryURL,
    MatchingSetPendingReportQueryURL,
    PendingRetouchTransfersQueryURL,
    RawImageUploadQueryURL,
    RawImageReviewQueryURL,
    BatchOutputQueryURL,
    BatchProcessTrackingQueryURL,
    ProductPomMeasurementQueryURL
};
